import { useQuery } from "react-query";

import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { CpcSchema, type Cpc } from "./useCpcSelector";

export const getOneCpcApiKey = "getOneCpc";

export const useGetOneCpc = (code: string | null | undefined, options?: { enabled?: boolean }) => {
    const { enabled = true } = options ?? {};
    const normalizedCode = code?.trim() ?? "";
    const isEnabled = enabled && normalizedCode !== "";

    const query = useQuery({
        queryKey: [getOneCpcApiKey, normalizedCode],
        queryFn: async () => {
            return await loggedInApiCall.get(`/api/cpc/${encodeURIComponent(normalizedCode)}`);
        },
        select: (response): Cpc => {
            return zodParseWithDetailedLog(response.data, CpcSchema, {
                operation: "GET",
                endpoint: "/cpc/:code",
            });
        },
        enabled: isEnabled,
        staleTime: 300_000,
        cacheTime: 300_000,
    });

    return {
        cpc: query.data,
        ...query,
    };
};
